// extracted by mini-css-extract-plugin
export default {"addTemplate":"styles_addTemplate__UdhkC","inputFields":"styles_inputFields__yQJR7","downloadBtnContainer":"styles_downloadBtnContainer__Ae5on"};